/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioTiposClientesCV from './controladorVista/formularioTiposClientesCV';
import TablaTiposClientesCV from './controladorVista/tablaTiposClientesCV';
import { estadoIncial, reductor } from './reductorTiposClientes';

const TiposClientes: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTiposClientesCV />
        <FormularioTiposClientesCV />
    </ProveedorEstado>
);

export default TiposClientes;
